import {ApiCollection} from "./api.collection";
import {Employee} from "../models/employee.model";


export const Employees = ApiCollection.extend({
    model: Employee,
    url: 'api/employees',
});
